import {
  GET_SUBMISSION_FORMS,
  GET_SUBMISSION_FORMS_LIST,
  GET_SUBMISSION_FORMS_MINIMAL,
  GET_SUBMISSION_FORM,
  ADD_SUBMISSION_FORM,
  DELETE_SUBMISSION_FORM,
  UPDATE_SUBMISSION_FORM,
  SUBMISSION_FORMS_LOADING,
  SUBMISSION_FORM_LOADING,
  CLEAR_CURRENT_SUBMISSION_FORM,
  SET_SUBMISSION_FORMS_PAGE
} from '../actions/types';

const initialState = {
  submissionForms: [],              // Lightweight list for table
  minimalSubmissionForms: [],       // Ultra-lightweight list for dropdowns (only _id, title, repeatable)
  currentSubmissionForm: null,      // Full submission form data for view/edit pages
  loading: false,                   // For list loading
  submissionFormLoading: false,     // For single submission form loading
  currentPage: 1,                   // Current page number
  totalPages: 0,                    // Total number of pages
  totalSubmissionForms: 0,          // Total number of submission forms
  hasNextPage: false,               // Whether there's a next page
  hasPrevPage: false                // Whether there's a previous page
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_SUBMISSION_FORMS_MINIMAL:
      return {
        ...state,
        minimalSubmissionForms: action.payload,
        loading: false
      };

    case GET_SUBMISSION_FORMS_LIST:
      return {
        ...state,
        submissionForms: action.payload.submissionForms || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalSubmissionForms: action.payload.totalSubmissionForms || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };

    case GET_SUBMISSION_FORM:
      return {
        ...state,
        currentSubmissionForm: action.payload,
        submissionFormLoading: false
      };

    case SUBMISSION_FORM_LOADING:
      return { ...state, submissionFormLoading: true };

    case CLEAR_CURRENT_SUBMISSION_FORM:
      return { ...state, currentSubmissionForm: null, submissionFormLoading: false };

    case ADD_SUBMISSION_FORM:
      return {
        ...state,
        // Add lightweight version to list
        submissionForms: [
          {
            _id: action.payload._id,
            title: action.payload.title,
            courseId: action.payload.courseId,
            description: action.payload.description,
            linkRequired: action.payload.linkRequired,
            commentRequired: action.payload.commentRequired,
            achievementImageRequired: action.payload.achievementImageRequired,
            automaticApproval: action.payload.automaticApproval,
            isActive: action.payload.isActive,
            tags: action.payload.tags,
            repeatable: action.payload.repeatable,
            createdAt: action.payload.createdAt,
            updatedAt: action.payload.updatedAt
          },
          ...state.submissionForms
        ],
        currentSubmissionForm: action.payload
      };

    case UPDATE_SUBMISSION_FORM:
      return {
        ...state,
        // Update in list
        submissionForms: state.submissionForms.map(form =>
          form._id === action.payload._id
            ? {
                _id: action.payload._id,
                title: action.payload.title,
                courseId: action.payload.courseId,
                description: action.payload.description,
                linkRequired: action.payload.linkRequired,
                commentRequired: action.payload.commentRequired,
                achievementImageRequired: action.payload.achievementImageRequired,
                automaticApproval: action.payload.automaticApproval,
                isActive: action.payload.isActive,
                tags: action.payload.tags,
                repeatable: action.payload.repeatable,
                createdAt: action.payload.createdAt,
                updatedAt: action.payload.updatedAt
              }
            : form
        ),
        currentSubmissionForm: action.payload
      };

    case DELETE_SUBMISSION_FORM:
      return {
        ...state,
        submissionForms: state.submissionForms.filter(
          form => form._id !== action.payload
        ),
        currentSubmissionForm: null
      };

    case SUBMISSION_FORMS_LOADING:
      return {
        ...state,
        loading: true
      };

    case GET_SUBMISSION_FORMS: // Keep for backward compatibility
      return {
        ...state,
        submissionForms: action.payload,
        loading: false
      };

    case SET_SUBMISSION_FORMS_PAGE:
      return { ...state, currentPage: action.payload };

    default:
      return state;
  }
} 